import React from 'react';
import { BaseComponentInterface } from '../base/base_component_interface';

// @todo this is a temporary component and probably should be layout schema
// import components
import { Flexbox, Picture, PhoneNumber, OpeningHours } from '../..';

/**
 * DeprecatedHeader component
 */
class DeprecatedHeader extends BaseComponentInterface {

    render() {
        const openingHoursProps = {
            contentProps: {
                innerHTML: 'Mon - Fri 9am – 8pm <br /> Sat 10am – 3pm'
            },
            visualProps: {
                size: 'small',
                color: 'black',
                textAlign: 'right'
            },
            elementProps: {
                tagName: 'strong'
            }
        };
        const phoneProps = {
            elementProps: {
                href: 'tel:1300-798-697'
            },
            contentProps: {
                label: '1300 798 697'
            },
            visualProps: {
                color: 'secondary',
                size: 'xxxlarge'
            }
        };
        const logoProps = {
            elementProps: {
                source: [
                    {
                        srcSet: '/evt/assets/brand/ctm/images/logo-large.png, /evt/assets/brand/ctm/images/logo-large@2x.png 2x',
                        media: '(min-width: 992px)'
                    },
                    {
                        srcSet: '/evt/assets/brand/ctm/images/logo-sm.png, /evt/assets/brand/ctm/images/logo-sm@2x.png 2x',
                        media: '(min-width: 768px)'
                    },
                    {
                        srcSet: '/evt/assets/brand/ctm/images/logo-xs.png, /evt/assets/brand/ctm/images/logo-xs@2x.png 2x'
                    }
                ],
                image: {
                    alt: 'Comparethemarket.com.au The easier way to save',
                    src: '/evt/assets/brand/ctm/images/logo-large.png'
                }
            }
        };
        return (
            <Flexbox visualProps={{ containerFluid: true, bgColor: 'white', border: 'bottom' }}>
                <Flexbox visualProps={{ container: true }}>
                    <Flexbox visualProps={{ row: true, variant: 'header' }}>
                        <Flexbox visualProps={{ xs: 12, sm: 6, md: 8 }}>
                            <Picture { ...logoProps } />
                        </Flexbox>
                        <Flexbox visualProps={{ xs: 0, sm: 6, md: 4 }}>
                            <PhoneNumber { ...phoneProps } />
                            <OpeningHours { ...openingHoursProps } />
                        </Flexbox>
                    </Flexbox>
                </Flexbox>
            </Flexbox>
        );
    }

}

export { DeprecatedHeader };
